import { z } from "zod";

export const ACCRUAL_MATCH_AUDIT_FIELD = "accrualMatches" as const;

export const ACCRUAL_MATCH_DIFF_FIELD = "matches" as const;

export enum AccrualMatchAuditItemType {
    TRANSACTION = "transaction",
    INVOICE_LINE_ITEM = "invoiceLineItem",
    BILL_LINE_ITEM = "billLineItem",
}

const entitySummarySchema = z.object({
    id: z.number().int(),
    name: z.string().nullable(),
    iconColor: z.string(),
    workspaceId: z.string().uuid(),
    logo: z.string().nullable(),
});

export type AccrualMatchAuditEntitySummary = z.infer<
    typeof entitySummarySchema
>;

const baseItemSchema = z.object({
    id: z.string(),
    type: z.nativeEnum(AccrualMatchAuditItemType),
    date: z.coerce.date(),
    description: z.string().nullable(),
    counterpartyName: z.string().nullable(),
    amount: z.number(),
    openAmount: z.number().nullable().optional(),
    accountIds: z.array(z.string()),
    classIds: z.array(z.string()),
    entityId: z.number().int(),
    entity: entitySummarySchema,
});

export const accrualMatchAuditLineItemSnapshotSchema = baseItemSchema.extend({
    type: z.union([
        z.literal(AccrualMatchAuditItemType.INVOICE_LINE_ITEM),
        z.literal(AccrualMatchAuditItemType.BILL_LINE_ITEM),
    ]),
    documentId: z.string(),
    documentNumber: z.string().nullable(),
});

export const accrualMatchAuditTransactionSnapshotSchema = baseItemSchema.extend(
    {
        type: z.literal(AccrualMatchAuditItemType.TRANSACTION),
        transactionId: z.number().int(),
    },
);

export const accrualMatchAuditItemSchema = z.union([
    accrualMatchAuditTransactionSnapshotSchema,
    accrualMatchAuditLineItemSnapshotSchema,
]);

export type AccrualMatchAuditItem = z.infer<typeof accrualMatchAuditItemSchema>;
export type AccrualMatchAuditLineItemSnapshot = z.infer<
    typeof accrualMatchAuditLineItemSnapshotSchema
>;
export type AccrualMatchAuditTransactionSnapshot = z.infer<
    typeof accrualMatchAuditTransactionSnapshotSchema
>;

export const accrualMatchAuditSnapshotSchema = z.object({
    transaction: accrualMatchAuditTransactionSnapshotSchema,
    items: z.array(accrualMatchAuditItemSchema),
});

export type AccrualMatchAuditSnapshot = z.infer<
    typeof accrualMatchAuditSnapshotSchema
>;
